import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'
import { Alert } from '@mui/material'

const styles = {
  success: {
    backgroundColor: '#0C130D',
    color: '#CCE8CD',
  },
  info: {
    backgroundColor: '#071318',
    color: '#B8E7FB'
  },
  warning: {
    backgroundColor: '#191207',
    color: '#FFE2B7'
  },
  error: {
    backgroundColor: '#160B0B',
    color: '#F4C7C7'
  },
}

const CustomAlert = styled(Alert)`
  width: 100%;
  border-radius: 10;
  font-size: ${fontSize('md')};
  display: flex;
  align-items: center;

  // NOTE: I'm not sure if this is doing anything...
  .MuiAlert-action: { padding: 0; }
`


const StyledAlert = ({ kind, AlertStyles, slotProps, children, }) => (
  <CustomAlert
    severity={kind}
    style={{
      ...(styles[kind] || styles['success']),
      ...AlertStyles
    }}
    slotProps={slotProps}>
    {children}
  </CustomAlert>
)

export default StyledAlert
